import { Outlet } from "react-router-dom";

import VersionIndicator from "@/components/VersionIndicator";

const App = () => {
  return (
    <>
      <Outlet />
      <VersionIndicator />
    </>
  );
};

export default App;
